import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRockClimbingNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.33 14.44a3.73 3.73 0 003.73 3.73 4.72 4.72 0 001.74-.33 8.536 8.536 0 013.24-.63h.45c.859.005 1.714.106 2.55.3l8.88 2.11c.17.04.345.06.52.06a2.253 2.253 0 002.23-2.24 6.449 6.449 0 00-2.44-5.1l-9.4-7.54a1.964 1.964 0 00-2.96.61L7.46 8.06a1.168 1.168 0 01-1.03.62h-.39l-.87-1.63.69-.84a1.709 1.709 0 10-2.78-1.97 1.681 1.681 0 00-.04 1.68l.48.92-.08.08a10.56 10.56 0 00-3.11 7.52zm3.73 2.38a2.394 2.394 0 01-2.39-2.38c0-.808.108-1.612.32-2.39l2.521 4.74c-.15.02-.3.03-.45.03zm18.27.61a.898.898 0 01-1.1.87l-8.88-2.1a12.292 12.292 0 00-2.48-.32l-1.12-2.11 13.56 3.21c.01.15.02.3.02.45zM8.65 8.69l1.41-2.64a.625.625 0 01.93-.19l1.41 1.13-3.17 4.15 1.44.34 2.79-3.64 1.41 1.13-2.25 2.97 1.44.35 1.87-2.47 1.43 1.15L16 12.75l1.44.34.98-1.27 1.97 1.58c.2.155.384.33.55.52.185.185.35.39.49.61.218.301.393.63.52.98L7.9 12.19l-1.15-2.18a2.516 2.516 0 001.9-1.32zM4.24 4.94a.329.329 0 01.3-.18.359.359 0 01.33.21.348.348 0 01-.05.38l-.34.41-.25-.47a.34.34 0 01.01-.35zm-.05 3.15l1.03 1.94h.01l.91 1.71-.01.05.04.01 2.18 4.1a9.751 9.751 0 00-2.52.491l-3.207-6.026A9.075 9.075 0 014.19 8.09z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsRockClimbingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRockClimbingNormalSmall;
